function HeadingSkipped() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>A heading level is skipped.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>Headings provide document structure and facilitate keyboard navigation by users of assistive technology. These users may be confused or experience difficulty navigating when heading levels are skipped.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Restructure the document headings to ensure that heading levels are not skipped.</p>
    </blockquote>
  )
}

export default HeadingSkipped